import { PrincipalModel } from "../../../../api/models";

export const getPrincipalBackgroundCheckStatus = (
  principal: PrincipalModel,
) => {
  if (!principal) return {};

  const paymentRequired = !principal.stripeInvoicePaidAt;
  const hasVerifiedBackgroundChecks =
    (principal.backgroundchecks?.length || 0) > 0;
  const pendingBackgroundChecks =
    !hasVerifiedBackgroundChecks && !paymentRequired;

  const isVerifiedPrincipal = !paymentRequired && hasVerifiedBackgroundChecks;

  return {
    paymentRequired,
    pendingBackgroundChecks,
    isVerifiedPrincipal,
  };
};
